import AppButton from '@/components/atoms/AppButton';
import AppTable from '@/components/atoms/AppTable';
import type { DeleteClinic } from '@/types/admin-delete-clinic';
import type { TableProps } from 'antd';
import { EllipsisH } from '@/components/atoms/AppIcon';
import { SITE_TYPE_LABELS } from '@/shared/constants/siteTypes';

interface DeleteClinicTableProps {
  data: DeleteClinic[];
  loading?: boolean;
  onRestoreClick?: (record: DeleteClinic) => void;
  tenantNameBySiteType?: Map<string, string>;
  showSiteTypeColumn?: boolean;
}

const formatDeletedAt = (value: string | null): string => {
  if (!value) return '';
  const match = /(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})/.exec(value);
  return match ? `${match[1]} ${match[2]}` : value;
};

const DeleteClinicTable = ({ data, loading, onRestoreClick, tenantNameBySiteType, showSiteTypeColumn }: DeleteClinicTableProps) => {
  const columns: TableProps<DeleteClinic>['columns'] = [
    {
      title: '治療院ID',
      dataIndex: 'clinic_number',
      key: 'clinic_number',

    },
    ...(showSiteTypeColumn
      ? [{
        title: 'サイト区分',
        key: 'site_type',
        render: (_: unknown, record: DeleteClinic) => {
          const st = record.site_type;
          if (!st) return '';
          return tenantNameBySiteType?.get(st) ?? SITE_TYPE_LABELS[st] ?? st;
        },
      }]
      : []),
    {
      title: '削除日',
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      width: 250,
      render: (_, record) => (
        <span className={record.expired ? 'text-red-600' : ''}>
          {formatDeletedAt(record.deleted_at)}
        </span>
      ),
    },
    {
      title: '操作',
      key: 'action',
      width: 140,
      render: (_, record) => (
        <AppButton
          icon={<EllipsisH />}
          type="primary"
          onClick={() => onRestoreClick?.(record)}
          aria-label="復元"
        >
          復元
        </AppButton>
      ),
    },
  ];

  return (
    <AppTable<DeleteClinic>
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey="id"
    />
  );
};

export default DeleteClinicTable;
